
          var import_meta_document = new DocumentFragment()
        
          
          export default import_meta_document
        